import { Injectable } from "@angular/core";
import { Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable()
export class CertificadosService {
    [x: string]: any;

    public url;
    public identity;
    public token;
    constructor(private _http: Http) {
        this.url = GLOBAL.url;
    }

    getPasos() {
        return this._http.get("assets/json/pasos_cert.json")
            .pipe(map(res => res.json()));
    }


    getSolicitante(rut) {
        let params = {
            rut: rut
        };

        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/solicitante', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    saveSolicitante(user) {
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/solicitante', user, { headers: headers })
            .pipe(map(res => res.json()));
    }

    getRol(rol) {
        let params = {
            rol: rol
        };

        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/rol', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    getPropiedades(rol?, id?, dir?, num?) {
        var params;

        if (rol && dir == undefined && num == undefined) {
            params = {
                rol: rol,
                id: id
            }
        }
        if (dir && num && rol == undefined) {
            params = {
                dir: dir,
                num: num
            }
        }
        console.log("params", params)
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/propiedades', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    savePropiedades(rol) {
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'save/propiedades', rol, { headers: headers })
            .pipe(map(res => res.json()));
    }

    getTipo_cert() {
        let params = {};
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/tipos_certificados', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    getCorviFM() {
        let params = {};
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })

        return this._http.post(this.url + 'get/corvi', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    get_certificado(rut) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        })

        let paramas = {
            rut: rut
        }

        return this._http.post(this.url + 'cert/get_certificado', paramas, { headers: headers })
            .pipe(map(res => res.json()));
    }

    get_Doc_cert(certificado) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        })

        let paramas = {
            firma_id: certificado._TRA_Firma
        }

        return this._http.post(this.url + 'cert/get_doc_cert', paramas, { headers: headers })
            .pipe(map(res => res.json()));
    }

    confirmarDescarga(info) {
        let headers = new Headers({
            'Content-Type': 'application/json'
        })

        let paramas = {
            info: info
        }

        return this._http.post(this.url + 'cert/confirmar_descarga', paramas, { headers: headers })
            .pipe(map(res => res.json()));
    }


}